import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./About.scss";
import  AppWrap  from "../../wrapper/AppWrap";

import Node from '../../assets/node.png'
import Reacts from '../../assets/react.jpg'
import Typescript from '../../assets/typescript.png'
import NextJs from '../../assets/Next_js 13.jpg'
import Mongodb from '../../assets/mongo.jpg'
import Serverless from '../../assets/serverless.jpg'
import Mern from '../../assets/mern.jpg'

const product=[
  {logo:Node,title:"Node Js","description":"I have expertise in developing backends and APIs using Node.js, and my preferred framework for this is Express. I particularly enjoy using MongoDB to meet customers' specific requirements"},
  {logo:NextJs,title:"Next Js","description":"Next.js is my toolkit for building fast, user-friendly websites and allow me to code at all in one place"},
  {logo:Reacts,title:"React Js","description":"Pure React is my go-to choice for crafting visually appealing and high-performance admin panels or web apps."},
  {logo:Typescript,title:"TypeScript","description":"TypeScript is my coding sidekick. It simplifies the complex, and keeps my code clean and dependable."},
  {logo:Mongodb,title:"Mongodb","description":"Mongodb is my preferable one for database handling like storing the information"},
  {logo:Serverless,title:"AWS Serverless","description":"Serverless allow me to build scalable system and also allow me to build microservices"},
  {logo:Mern,title:"MERN",description:"It is my favourable one to build a full stack application"}
]

const About=()=>{
    const [abouts,setAbouts]=useState(product);
return (
    <>
      <h2 className="head-text">
        <span>Problem-solving is my job.</span> <br />
        Exploring New Tools to <span>Enhance My Capabilities.</span>
      </h2>

      <div className="app__profiles">
         {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={about.logo} alt={about.title} /> 
             <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))} 
      </div>
    </>
  );
};

export default AppWrap(About, "about");